/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Mcp_TitleInputs */

const en_directory_mcp_title = /** @type {(inputs: Directory_Mcp_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seek AI MCP server`)
};

const zh_directory_mcp_title = /** @type {(inputs: Directory_Mcp_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seek AI MCP 服务器`)
};

/**
* | output |
* | --- |
* | "Seek AI MCP server" |
*
* @param {Directory_Mcp_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_mcp_title = /** @type {((inputs?: Directory_Mcp_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Mcp_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_mcp_title(inputs)
	return zh_directory_mcp_title(inputs)
});
export { directory_mcp_title as "directory.mcp.title" }